// background-control.service.ts
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BackgroundControlService {
  private showBackgroundSubject = new BehaviorSubject<boolean>(true);
  showBackground$ = this.showBackgroundSubject.asObservable();

  get bgShown(): boolean {
    return this.showBackgroundSubject.getValue();
  }

  setShowBackground(show: boolean) {
    this.showBackgroundSubject.next(show);
  }
}
